<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading" epub:type="dedication" id="dedication" role="doc-dedication">
<div class="text" id="dedication-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>For my cousin, Lizzy Dent – I can’t believe</i></p>
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>we both grew up to be novelists!</i></p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>And for librarians everywhere – thank you for spreading the love.</i></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?726e878e